export const mainSearchBarSearchStyles = {
	root: (fullWidth: boolean, fullHeight: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxWidth: '663px',
		width: {
			xs: fullWidth ? '100%' : '70%',
			md: '100%'
		},
		height: fullHeight ? '56px' : '44px'
	}),
	searchRoot: {
		backgroundColor: 'background.paper',
		borderRadius: '56px',
		boxShadow: '0 0 5px rgba(0,0,0,.1)',
		transition: 'box-shadow 0.2s ease-out',
		padding: '4px 8px',
		border: 'unset !important',

		':has(.Mui-focused)': {
			boxShadow: '0 0 10px rgba(0,0,0,.2)'
		}
	},
	searchInput: {
		ml: 1,
		flex: 1,
		lineHeight: 1.5,
		fontWeight: 400,
		fontSize: '1.125rem'
	},
	searchIcon: {
		width: 22,
		height: 22
	},
	dropdown: {
		maxHeight: `calc(70vh - 200px)`,
		'@media (min-height: 1100px)': {
			maxHeight: 'unset'
		}
	},
	linkBox: {
		maxWidth: '663px',
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-end'
	},
	link: {
		textDecoration: 'none',
		color: 'text.primary',
		display: 'inline-flex',
		p: 1,
		fontWeight: 400
	}
};
